import FormRender from "@/components/Form/Renderer/RenderForm";
import { addEmployee } from "@/services/employee.services";
import { AddEmployeeConfig } from "@/utils/constant/formConfig.constant";
import { toastMessage } from "@/utils/helper/myToast";
import { filterTruthyValues } from "@/utils/helper/string";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface AddEmployeeProps {
  onClose: (props?: any) => void;
  afterCall: any;
}

const AddEmployee: React.FC<AddEmployeeProps> = ({ onClose, afterCall }) => {
  const navigate = useNavigate();
  const [propsData, setData] = useState<any>(null);

  useEffect(() => {
    if (afterCall) {
      setData({ afterCall });
    }
  }, [afterCall]);

  const handleFormSubmit = async (formData: any) => {
    const res: any = await addEmployee(filterTruthyValues(formData));
    if (res?.status === 200) {
      const { message, isError } = res.data;
      onClose({ disabledWarning: true });
      if (propsData?.afterCall) {
        setTimeout(() => {
          propsData.afterCall();
        }, 10);
      }
      navigate("/home/employees", { replace: true });
      return toastMessage(message, isError);
    } else {
      console.log("Error", res);
      const { message, isError } = res?.response?.data || {};
      if (message) {
        return toastMessage(message, isError);
      }
      if (res.message) {
        return toastMessage(res.message, true);
      }
    }
  };
  return (
    <FormRender
      useFormConfig={{ mode: "onSubmit", reValidateMode: "onChange", criteriaMode: "all" }}
      handleFormSubmit={handleFormSubmit}
      handleCancel={onClose}
      formConfig={AddEmployeeConfig}
      className="p-4 overflow-y-auto h-[calc(100%-30px)]"
      formClassName=""
      btnContainerClass=" sticky bottom-0 bg-white py-5"
    />
  );
};

export default AddEmployee;
